/* sv-anyart 0.37.0, image rights tick 0.38.0: pick one of our designs or upload your own, add a name, see the print.
   Posts everything as line item properties on the native product form.
   Pairs with snippets/sv-anyart.liquid. */
(function () {
  'use strict';
  var PAGE = 48;

  function $(s, r) { return (r || document).querySelector(s); }
  function $$(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }

  function boot(root) {
    var st = {
      mode: root.querySelector('[data-aa-panel="design"]') ? 'design' : 'upload', designs: [], themes: [], cdn: '', shown: PAGE, theme: '', q: '',
      pick: null, img: null, upImg: null, upOk: false,
      face: 'Luckiest Guy', faceName: 'Bold', ink: '#0E2B22', inkName: 'Pine'
    };
    var ratio = parseFloat(root.dataset.ratio) || 1;
    /* 0.42.2: the print area's shape and safe margin come from Printify's own placeholders (vault.anyart_spec),
       per variant where sizes differ (a portrait canvas is not a landscape one), and a round or shaped item keeps
       the artwork and name further in so nothing runs off the circle or round a phone's curve. */
    var SPEC = {}; try { SPEC = JSON.parse(root.dataset.spec || '{}') || {}; } catch (e) {}
    function curRatio() {
      var f = document.querySelector('form[action*="/cart/add"]'), idEl = f && f.querySelector('[name="id"]');
      var id = idEl ? String(idEl.value) : '';
      return (SPEC.ratios && parseFloat(SPEC.ratios[id])) || ratio;
    }
    var minpx = parseInt(root.dataset.min, 10) || 1200;
    var maxpx = parseInt(root.dataset.max, 10) || 12000;
    var bg = root.dataset.bg || '#FFFFFF';
    var grid = $('[data-aa-grid]', root), more = $('[data-aa-more]', root);
    var canvas = $('[data-aa-canvas]', root), ctx = canvas.getContext('2d');
    var nameEl = $('[data-aa-name]', root), cnt = $('[data-aa-cnt]', root);
    var fileEl = $('[data-aa-file]', root);
    var need = $('[data-aa-need]', root);

    /* ---- the product form, and associating our controls with it ---- */
    function form() { return document.querySelector('form[action*="/cart/add"]'); }
    function adopt() {
      var f = form(); if (!f) return;
      /* Read the ATTRIBUTE: f.id is the variant <input name="id"> (see sv-photo.js). */
      var fid = f.getAttribute('id');
      if (!fid) { fid = 'sv-cart-add-form'; f.setAttribute('id', fid); }
      f.setAttribute('enctype', 'multipart/form-data');
      f.setAttribute('data-sv-native', '1');
      $$('input', root).forEach(function (el) {
        if (el.closest('form') !== f) el.setAttribute('form', fid);
      });
    }
    function buttons() {
      var f = form(); if (!f) return [];
      return $$('[type="submit"], button[name="add"], .add-to-cart-button', f);
    }
    var rightsEl = $('[data-aa-rights]', root), rightsProp = $('[data-aa-rightsprop]', root), rightsNeed = $('[data-aa-rightsneed]', root);
    var RIGHTS = 'Customer confirmed they own this image or have permission to print it, and accepted responsibility for its use (image rights wording v1, 24 Sep 2026)';
    function rightsOk() { return !!(rightsEl && rightsEl.checked); }
    function ready() {
      return st.mode === 'design' ? !!st.pick : (st.upOk && rightsOk());
    }
    function gate() {
      var ok = ready();
      need.hidden = ok;
      /* Image rights: the record goes on the order only for an upload the shopper confirmed. */
      if (rightsProp) {
        var on = st.mode === 'upload' && st.upOk && rightsOk();
        rightsProp.value = on ? RIGHTS : ''; rightsProp.disabled = !on;
      }
      if (rightsNeed) rightsNeed.hidden = !(st.mode === 'upload' && st.upOk && !rightsOk());
      buttons().forEach(function (b) {
        if (!ok) { b.setAttribute('disabled', 'disabled'); b.dataset.svAaHeld = '1'; }
        else if (b.dataset.svAaHeld) { b.removeAttribute('disabled'); delete b.dataset.svAaHeld; }
      });
    }
    document.addEventListener('submit', function (e) {
      var f = form();
      if (e.target === f && !ready()) {
        e.preventDefault(); e.stopPropagation();
        var tgt = (st.mode === 'upload' && st.upOk && !rightsOk() && rightsNeed) ? rightsNeed : need;
        tgt.hidden = false; tgt.scrollIntoView({ block: 'center', behavior: 'smooth' });
      }
    }, true);

    /* ---- mode tabs ---- */
    $$('[data-aa-mode]', root).forEach(function (b) {
      b.addEventListener('click', function () {
        st.mode = b.dataset.aaMode;
        $$('[data-aa-mode]', root).forEach(function (x) {
          var on = x === b; x.classList.toggle('is-on', on); x.setAttribute('aria-selected', on ? 'true' : 'false');
        });
        $$('[data-aa-panel]', root).forEach(function (p) { p.hidden = p.dataset.aaPanel !== st.mode; });
        /* A file left in the input would still post with a design order, and a
           design left selected would still post with an upload. Clear the other side. */
        if (st.mode === 'design') { fileEl.value = ''; st.upImg = null; st.upOk = false; setProp('check', ''); $('[data-aa-ok]', root).hidden = true; $('[data-aa-bad]', root).hidden = true; }
        else { st.pick = null; setProp('design', ''); setProp('designcode', ''); setProp('art', ''); if (/^Design/.test(st.inkName)) pickInk('#0E2B22', 'Pine'); $$('.sv-aa__t.is-on', grid).forEach(function (t) { t.classList.remove('is-on'); }); }
        draw(); gate();
      });
    });

    /* An empty property is left out of the order rather than posted blank:
       a disabled control is not submitted. */
    function setProp(k, v) { var el = $('[data-aa-' + k + ']', root); if (el) { el.value = v; el.disabled = !v; } }
    ['design', 'designcode', 'check', 'art'].forEach(function (k) { setProp(k, ''); });
    nameEl.disabled = false;

    /* ---- designs ---- */
    function load() {
      fetch(root.dataset.designs).then(function (r) { return r.json(); }).then(function (j) {
        st.cdn = j.cdn || '';
        st.designs = (j.designs || []).filter(function (d) { return d[7]; });
        st.themes = j.themes || [];
        chips(); list();
      }).catch(function () { grid.innerHTML = '<p>Designs could not load. Refresh the page, or upload your own.</p>'; });
    }
    function chips() {
      var wrap = $('[data-aa-themes]', root);
      var all = [['', 'All designs']].concat(st.themes.map(function (t) { return [t[0], t[1]]; }));
      wrap.innerHTML = all.map(function (t, i) {
        return '<button type="button" class="sv-aa__chip' + (i === 0 ? ' is-on' : '') + '" data-th="' + t[0] + '">' + t[1] + '</button>';
      }).join('');
      $$('.sv-aa__chip', wrap).forEach(function (c) {
        c.addEventListener('click', function () {
          $$('.sv-aa__chip', wrap).forEach(function (x) { x.classList.remove('is-on'); });
          c.classList.add('is-on'); st.theme = c.dataset.th; st.shown = PAGE; list();
        });
      });
    }
    function matches() {
      var q = st.q.toLowerCase().trim();
      return st.designs.filter(function (d) {
        if (st.theme && d[2] !== st.theme) return false;
        if (!q) return true;
        return (d[1] + ' ' + d[2] + ' ' + (d[10] || '')).toLowerCase().indexOf(q) !== -1;
      });
    }
    function list() {
      var m = matches();
      grid.innerHTML = m.slice(0, st.shown).map(function (d) {
        return '<button type="button" class="sv-aa__t' + (st.pick && st.pick[0] === d[0] ? ' is-on' : '') + '" data-id="' + d[0] + '">' +
          '<img src="' + st.cdn + d[7].split('?')[0] + '?width=240" alt="" loading="lazy" width="240" height="240"><span>' + esc(d[1]) + '</span></button>';
      }).join('') || '<p>No designs match that. Try another word, or upload your own.</p>';
      more.hidden = m.length <= st.shown;
      $$('.sv-aa__t', grid).forEach(function (t) {
        t.addEventListener('click', function () { choose(t.dataset.id); });
      });
    }
    function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
    /* Upload-only products (spec designs:false) render no design panel, so there is no grid to wire up. */
    if (grid) {
      more.addEventListener('click', function () { st.shown += PAGE; list(); });
      $('[data-aa-q]', root).addEventListener('input', function (e) { st.q = e.target.value; st.shown = PAGE; list(); });
    }

    function choose(id) {
      wordTake(id);
      var d = st.designs.find(function (x) { return x[0] === id; });
      if (!d) return;
      st.pick = d;
      $$('.sv-aa__t', grid).forEach(function (t) { t.classList.toggle('is-on', t.dataset.id === id); });
      var src = st.cdn + d[7].split('?')[0];
      /* 0.46.7: the customer sees the design's name; its catalogue code (AR004) goes in the hidden _design */
      setProp('design', d[1]); setProp('designcode', d[0]);
      setProp('art', src);
      if (d[9]) pickInk(d[9], 'Design colour ' + String(d[9]).toUpperCase());
      var im = new Image(); im.crossOrigin = 'anonymous';
      im.onload = function () { if (st.pick === d) { st.img = im; draw(); } };
      im.src = src + '?width=1200';
      st.img = null; draw(); gate();
    }

    if (rightsEl) rightsEl.addEventListener('change', gate);

    /* ---- upload, with Tony's file rule ---- */
    fileEl.addEventListener('change', function () {
      var ok = $('[data-aa-ok]', root), bad = $('[data-aa-bad]', root);
      ok.hidden = true; bad.hidden = true; st.upOk = false; st.upImg = null; setProp('check', '');
      var f = fileEl.files && fileEl.files[0];
      if (!f) { draw(); gate(); return; }
      if (!/^image\/(jpeg|png)$/.test(f.type)) { fail('That file is not a JPEG or PNG. Save it as one of those and choose it again.'); return; }
      if (f.size > 20 * 1024 * 1024) { fail('That file is over 20 MB. Save it a little smaller and choose it again.'); return; }
      var url = URL.createObjectURL(f), im = new Image();
      im.onload = function () {
        var w = im.naturalWidth, h = im.naturalHeight, long = Math.max(w, h);
        if (long < minpx) { fail(w + ' x ' + h + ' pixels is too small to print sharply. We need at least ' + minpx + ' pixels on the longest side. Use the original file, not one saved from social media or a message.'); return; }
        if (long > maxpx) { fail(w + ' x ' + h + ' pixels is larger than we can take. Save it at under ' + maxpx + ' pixels on the longest side and choose it again.'); return; }
        st.upImg = im; st.upOk = true;
        setProp('check', w + ' x ' + h + ' px, meets our ' + minpx + ' px minimum');
        ok.textContent = 'Got it: ' + w + ' x ' + h + ' pixels. That will print well.';
        ok.hidden = false; draw(); gate();
      };
      im.onerror = function () { fail('We could not read that image. Try saving it again as a JPEG or PNG.'); };
      im.src = url;
      function fail(msg) { fileEl.value = ''; bad.textContent = msg; bad.hidden = false; draw(); gate(); }
    });

    /* ---- lettering ---- */
    /* A blank name is left off the order: a control with no name attribute is not submitted,
       and unlike disabling it, the field stays typeable. */
    function nameAttr() { if (nameEl.value.trim()) nameEl.setAttribute('name', 'properties[Name]'); else nameEl.removeAttribute('name'); }
    nameEl.addEventListener('input', function () { cnt.textContent = nameEl.value.length; nameAttr(); draw(); });
    nameAttr();
    $$('.sv-aa__f', root).forEach(function (b) {
      b.addEventListener('click', function () {
        $$('.sv-aa__f', root).forEach(function (x) { x.classList.toggle('is-on', x === b); });
        st.face = b.dataset.face; st.faceName = b.dataset.faceName; setProp('faceprop', st.faceName); draw();
      });
    });
    /* 0.46.7: the cart, checkout and packing slip read "Lettering colour: As drawn", not "Design colour #0E4429";
       the hex goes to the press in the hidden _ink (fulfil_anyart reads _ink first). */
    function pickInk(hex, name) {
      st.ink = hex; st.inkName = name; setProp('inkprop', /^Design colour/.test(name) ? 'As drawn' : name); setProp('inkhex', hex);
      $$('.sv-aa__i', root).forEach(function (x) { x.classList.toggle('is-on', x.dataset.ink.toLowerCase() === String(hex).toLowerCase()); });
    }
    $$('.sv-aa__i', root).forEach(function (b) {
      b.addEventListener('click', function () { st.inkManual = true; st.autoPrev = null; pickInk(b.dataset.ink, b.dataset.inkName); draw(); });
    });

    /* ---- the preview: the print area's own proportions, art above, name below ---- */
    /* 0.42.2: OUR DESIGNS PRINT STRAIGHT ONTO THE PRODUCT, NO WHITE BOX. The print file used to carry a white
       rectangle, so a grey jumper or a teal cap came back with a white panel round the artwork. A design now goes to
       the printer as a cut-out, so the preview paints the colour the shopper has picked behind it, and pine lettering
       on a black jumper looks as hard to read here as it would in the parcel. An upload is a photo and keeps white. */
    /* 0.46.6: the 17 colour names the first list missed (crop tee, hoodies, totes), so those grounds are no longer white */
    var GROUNDS = [['dark heather', '#474a51'], ['mint', '#a8e0c8'], ['atlantic', '#2b4f6e'], ['cypress', '#4a5d4f'], ['ecru', '#e9e1cf'],
      ['plum', '#5d2f4f'], ['bone', '#e8e0d0'], ['bubblegum', '#f5a3c7'], ['coal', '#333333'], ['orchid', '#b98cc2'], ['sage', '#a3b39a'],
      ['heliconia', '#e6457a'], ['butter', '#f6e3a1'], ['crimson', '#9e1b32'], ['denim', '#4f6d8f'], ['pepper', '#5a5a58'], ['espresso', '#4b3428'],
      ['heather grey', '#cfcfcf'], ['sport grey', '#bdbdbd'], ['ash', '#dcdcdc'], ['light grey', '#d6d6d6'],
      ['charcoal', '#3b3b3b'], ['dark grey', '#4a4a4a'], ['grey', '#b5b5b5'], ['gray', '#b5b5b5'], ['black', '#161616'],
      ['navy', '#1f2a44'], ['royal', '#2c4fa0'], ['light blue', '#aecbe8'], ['blue', '#3c6db3'], ['teal', '#0d6e6e'],
      ['forest', '#23402f'], ['bottle green', '#1f4d36'], ['military', '#4b5320'], ['green', '#2f6b3f'], ['maroon', '#5a1f27'],
      ['burgundy', '#5e1b2b'], ['red', '#b3262e'], ['pink', '#f4c2cf'], ['purple', '#5b3a7a'], ['orange', '#e0762c'],
      ['yellow', '#f2d24b'], ['natural', '#efe6d2'], ['cream', '#f3ecdc'], ['sand', '#e3d3b4'], ['beige', '#e6d8bd'],
      ['brown', '#6b4a33'], ['white', '#ffffff']];
    function ground() {
      var picked = [];
      document.querySelectorAll('variant-picker input:checked, .variant-picker input:checked, variant-picker select, .variant-picker select').forEach(function (el) {
        picked.push((el.value || '').toLowerCase());
      });
      for (var i = 0; i < picked.length; i++) {
        for (var j = 0; j < GROUNDS.length; j++) if (picked[i].indexOf(GROUNDS[j][0]) >= 0) return GROUNDS[j][1];
      }
      return bg;
    }
    /* 0.44.4: APPLE WATCH BAND (SPEC.panel 'band'). Tony: "Apple Watch band needs fixing". The print file is one
       strip about 0.11 wide by 1 tall that becomes BOTH straps; drawn like any other item it made a 3,000 px tall
       canvas on a phone, painted it black for "Black Matte" (the buckle colour, not the strap, which is white), and
       put the artwork where the watch sits, where nothing prints. Zones measured on Printify's own photographs of a
       calibration strip (fulfil_anyart.py BAND, same numbers): artwork on the buckle strap 13 to 29% of the strip,
       the name along the long strap 53.5 to 65.5%, reading from the watch outwards; no name, the artwork there too.
       The preview shows the two straps side by side, the way the strap arrives. */
    var BAND = { side: 0.14, art: [0.13, 0.29], name: [0.535, 0.655], short: [0.04, 0.32], long: [0.52, 0.97], holes: [0.67, 0.91] };
    function bandFile() {
      var fw = 300, fh = Math.round(fw / curRatio());
      var oc = document.createElement('canvas'); oc.width = fw; oc.height = fh;
      var o = oc.getContext('2d'); o.fillStyle = bg; o.fillRect(0, 0, fw, fh);
      var side = Math.round(fw * BAND.side), cw = fw - side * 2;
      var img = st.mode === 'design' ? st.img : st.upImg, name = nameEl.value.trim();
      function fit(y0, y1) {
        if (!img) {
          o.save(); o.strokeStyle = 'rgba(14,43,34,.35)'; o.setLineDash([10, 8]); o.lineWidth = 4;
          o.strokeRect(side, y0, cw, y1 - y0); o.restore(); return;
        }
        var s = Math.min(cw / img.naturalWidth, (y1 - y0) / img.naturalHeight), dw = img.naturalWidth * s, dh = img.naturalHeight * s;
        o.drawImage(img, side + (cw - dw) / 2, y0 + (y1 - y0 - dh) / 2, dw, dh);
      }
      var ay0 = Math.round(fh * BAND.art[0]), ay1 = Math.round(fh * BAND.art[1]);
      var ny0 = Math.round(fh * BAND.name[0]), ny1 = Math.round(fh * BAND.name[1]);
      fit(ay0, ay1);
      if (!name) { fit(ny0, ny1); return oc; }
      var L = ny1 - ny0, face = st.face, text = (face === 'Luckiest Guy' || face === 'Bangers') ? name.toUpperCase() : name;
      var size = Math.round(cw * 0.7);
      do { o.font = size + 'px "' + face + '", system-ui, sans-serif'; size -= 2; }
      while ((o.measureText(text).width > L * 0.94 || size > cw * 0.72) && size > 10);
      o.save(); o.translate(side + cw / 2, ny0 + L / 2); o.rotate(Math.PI / 2);
      o.textAlign = 'center'; o.textBaseline = 'middle';
      if (st.ink.toUpperCase() === '#FFFFFF' || st.ink.toUpperCase() === '#C2A049') {
        o.lineWidth = Math.max(2, size / 9); o.strokeStyle = '#0E2B22'; o.lineJoin = 'round'; o.strokeText(text, 0, 0);
      }
      o.fillStyle = st.ink; o.fillText(text, 0, 0); o.restore();
      return oc;
    }
    function drawBand() {
      if (st.autoPrev) { pickInk(st.autoPrev[0], st.autoPrev[1]); st.autoPrev = null; }
      var oc = bandFile(), fw = oc.width, fh = oc.height;
      var W = 600, H = 600; canvas.width = W; canvas.height = H;
      ctx.clearRect(0, 0, W, H); ctx.fillStyle = '#F4F1EA'; ctx.fillRect(0, 0, W, H);
      var s = 540 / ((BAND.long[1] - BAND.long[0]) * fh), trim = 0.1;
      var sx = fw * trim, sw = fw * (1 - trim * 2), dw = sw * s;
      function strap(cx, top, a, b, tip) {
        var y0 = fh * a, dh = (b - a) * fh * s, x = cx - dw / 2, r = dw * 0.12, rb = tip ? dw / 2 : r;
        ctx.save(); ctx.beginPath();
        ctx.moveTo(x + r, top); ctx.lineTo(x + dw - r, top); ctx.quadraticCurveTo(x + dw, top, x + dw, top + r);
        ctx.lineTo(x + dw, top + dh - rb); ctx.quadraticCurveTo(x + dw, top + dh, x + dw - rb, top + dh);
        ctx.lineTo(x + rb, top + dh); ctx.quadraticCurveTo(x, top + dh, x, top + dh - rb);
        ctx.lineTo(x, top + r); ctx.quadraticCurveTo(x, top, x + r, top); ctx.closePath();
        ctx.shadowColor = 'rgba(0,0,0,.18)'; ctx.shadowBlur = 10; ctx.shadowOffsetY = 3; ctx.fillStyle = '#fff'; ctx.fill();
        ctx.shadowColor = 'transparent'; ctx.clip();
        ctx.drawImage(oc, sx, y0, sw, (b - a) * fh, x, top, dw, dh);
        ctx.restore();
        ctx.strokeStyle = 'rgba(14,43,34,.18)'; ctx.lineWidth = 1; ctx.stroke();
        return { x: x, top: top, dh: dh };
      }
      var lg = strap(W * 0.33, 30, BAND.long[0], BAND.long[1], true);
      var sh = strap(W * 0.67, 70, BAND.short[0], BAND.short[1], false);
      ctx.fillStyle = '#2b2b2b';                                    /* lugs, buckle and keeper */
      ctx.fillRect(lg.x - 8, 22, dw + 16, 12); ctx.fillRect(sh.x - 8, 70 + sh.dh - 4, dw + 16, 12);
      ctx.lineWidth = 7; ctx.strokeStyle = '#2b2b2b'; ctx.strokeRect(sh.x - 6, 34, dw + 12, 44);
      var ky = 70 + (0.085 - BAND.short[0]) * fh * s; ctx.fillRect(sh.x - 3, ky, dw + 6, 0.025 * fh * s);
      ctx.fillStyle = 'rgba(60,60,60,.55)';                          /* holes */
      for (var i = 0; i < 11; i++) {
        var hy = 30 + ((BAND.holes[0] + (BAND.holes[1] - BAND.holes[0]) * i / 10) - BAND.long[0]) * fh * s;
        ctx.beginPath(); ctx.ellipse(W * 0.33, hy, 6, 3.5, 0, 0, Math.PI * 2); ctx.fill();
      }
    }
    /* 0.46.2 WOODEN LETTERS (SPEC.panel 'shape'). Tony: "fix graphics looks wrong check printify" (the S showed a
       sliver of the design and half of YOUR NAME) and "if you choose multiple letters should be able to do multiple
       designs per letter if wanted". Printify cuts every shape out of one 2421 x 2091 area, so a letter, number, &
       or Love prints our design as an all-over pattern (a photo fills it), with no name: the letter is the
       personalisation. Heart, Star and Hexagon keep one design and the name. fulfil_anyart.py render_tile() and
       shape_panel() draw the print the same way. The preview cuts the pattern to the shape on birch. */
    var SHAPEMODE = SPEC.panel === 'shape';
    var SOLID = { heart: 0.2, star: 0.27, hexagon: 0.12 };
    function curShape() {
      /* 0.46.4: while spelling a name, the preview shows the letter being worked on, in its own design */
      if (typeof word !== 'undefined' && word && word.pv) return word.pv;
      var c = document.querySelector('variant-picker input:checked, .variant-picker input:checked');
      if (c) return c.value;
      var s = document.querySelector('variant-picker select, .variant-picker select');
      return s ? s.value : 'A';
    }
    function isLetter(sh) { return !SOLID[String(sh).toLowerCase()]; }
    var nameWrap = nameEl.closest('.sv-aa__name'), nameStep = nameWrap && nameWrap.previousElementSibling;
    var letterNote = null;
    function nameForShape(sh) {
      if (!nameWrap) return;
      var off = isLetter(sh);
      nameWrap.hidden = off; if (nameStep) nameStep.hidden = off;
      nameEl.disabled = off;
      if (!letterNote) {
        letterNote = document.createElement('p'); letterNote.className = 'sv-aa__lnote';
        letterNote.textContent = 'On a letter, number, & or LOVE your design is printed all over it as a pattern, and the letter itself is the personalisation, so there is no name line. Heart, Star and Hexagon take one design with a name.';
        nameWrap.parentNode.insertBefore(letterNote, nameStep || nameWrap);
      }
      letterNote.hidden = !off;
    }
    function shapePath(c, sh, W, H) {
      var s = String(sh).toLowerCase(), cx = W / 2, cy = H / 2, r = Math.min(W, H) * 0.47;
      c.beginPath();
      if (s === 'heart') {
        var w = r * 2.05, h = r * 1.9, top = cy - h * 0.42;
        c.moveTo(cx, top + h * 0.28);
        c.bezierCurveTo(cx, top, cx - w / 2, top, cx - w / 2, top + h * 0.3);
        c.bezierCurveTo(cx - w / 2, top + h * 0.6, cx, top + h * 0.8, cx, top + h);
        c.bezierCurveTo(cx, top + h * 0.8, cx + w / 2, top + h * 0.6, cx + w / 2, top + h * 0.3);
        c.bezierCurveTo(cx + w / 2, top, cx, top, cx, top + h * 0.28);
      } else if (s === 'star') {
        for (var i = 0; i < 10; i++) {
          var a = -Math.PI / 2 + i * Math.PI / 5, rr = i % 2 ? r * 0.45 : r * 1.02;
          c[i ? 'lineTo' : 'moveTo'](cx + rr * Math.cos(a), cy + 0.06 * r + rr * Math.sin(a));
        }
      } else if (s === 'hexagon') {
        for (var k = 0; k < 6; k++) {
          var b = k * Math.PI / 3;
          c[k ? 'lineTo' : 'moveTo'](cx + r * 1.08 * Math.cos(b), cy + r * 1.08 * Math.sin(b));
        }
      } else {
        var txt = String(sh).toLowerCase() === 'love' ? 'LOVE' : String(sh).toUpperCase();
        var size = H * 0.98;
        c.font = '900 ' + size + 'px "Arial Black", "Helvetica Neue", Arial, sans-serif';
        var m = c.measureText(txt);
        if (m.width > W * 0.94) { size = size * W * 0.94 / m.width; c.font = '900 ' + size + 'px "Arial Black", "Helvetica Neue", Arial, sans-serif'; m = c.measureText(txt); }
        c.textAlign = 'center'; c.textBaseline = 'alphabetic';
        var asc = m.actualBoundingBoxAscent || size * 0.72, desc = m.actualBoundingBoxDescent || 0;
        c.fillText(txt, cx, cy + (asc - desc) / 2);
        return 'text';
      }
      c.closePath();
      return 'path';
    }
    function shapeFile(W, H, sh) {
      var oc = document.createElement('canvas'); oc.width = W; oc.height = H;
      var o = oc.getContext('2d');
      var img = st.mode === 'design' ? st.img : st.upImg;
      if (!img) return oc;
      if (isLetter(sh)) {
        if (st.mode !== 'design') {
          var sc = Math.max(W / img.naturalWidth, H / img.naturalHeight), dw = img.naturalWidth * sc, dh = img.naturalHeight * sc;
          o.drawImage(img, (W - dw) / 2, (H - dh) / 2, dw, dh);
        } else {
          var mh = W * 0.26, mw = img.naturalWidth * mh / img.naturalHeight, sx = mw * 1.18, sy = mh * 1.12;
          for (var row = 0, y = -sy / 3; y < H; y += sy, row++) {
            for (var x = (row % 2 ? -sx / 2 : 0) - sx / 4; x < W; x += sx) o.drawImage(img, x, y, mw, mh);
          }
        }
        return oc;
      }
      /* the same boxes as fulfil_anyart.py SHAPE_BOX: design x0, y0, x1, y1, then the name's centre line and widest */
      var BOX = { heart: [[0.24, 0.12, 0.76, 0.52], 0.63, 0.46], star: [[0.33, 0.28, 0.67, 0.58], 0.66, 0.36], hexagon: [[0.18, 0.1, 0.82, 0.68], 0.8, 0.66] };
      var bx = BOX[String(sh).toLowerCase()], name = nameEl.value.trim();
      var x0 = bx[0][0], y0 = bx[0][1], x1 = bx[0][2], y1 = bx[0][3];
      if (!name) y1 = String(sh).toLowerCase() === 'star' ? 0.66 : Math.min(bx[1] + 0.08, 0.9);
      var bw = W * (x1 - x0), bh = H * (y1 - y0), s2 = Math.min(bw / img.naturalWidth, bh / img.naturalHeight);
      o.drawImage(img, W * x0 + (bw - img.naturalWidth * s2) / 2, H * y0 + (bh - img.naturalHeight * s2) / 2, img.naturalWidth * s2, img.naturalHeight * s2);
      if (name) {
        var face = st.face, text = (face === 'Luckiest Guy' || face === 'Bangers') ? name.toUpperCase() : name, size = Math.round(H * 0.1);
        o.textAlign = 'center'; o.textBaseline = 'middle';
        do { o.font = size + 'px "' + face + '", system-ui, sans-serif'; size -= 2; } while (o.measureText(text).width > W * bx[2] && size > 10);
        var yy = H * bx[1];
        if (st.ink.toUpperCase() === '#FFFFFF' || st.ink.toUpperCase() === '#C2A049') { o.lineWidth = Math.max(2, size / 9); o.strokeStyle = '#0E2B22'; o.lineJoin = 'round'; o.strokeText(text, W / 2, yy); }
        o.fillStyle = st.ink; o.fillText(text, W / 2, yy);
      }
      return oc;
    }
    /* 0.46.4 SIZES. Tony: "also need dimensions on it letter sized etc". The maker's own size guide (Printify,
       Free-Standing Wooden Decor, WOYC), inches converted to cm: width and height per shape, all 2.2 cm thick. */
    var SIZES = {"&":[15.1,13.1],"STAR":[15.0,15.0],"HEXAGON":[20.0,20.0],"HEART":[15.0,15.0],"LOVE":[39.7,15.0],"A":[15.6,15.4],"B":[13.0,15.4],"C":[13.6,15.6],"D":[13.1,15.4],"E":[11.9,15.4],"F":[10.8,15.4],"G":[14.5,15.6],"H":[12.5,15.4],"I":[4.3,15.4],"J":[10.2,15.4],"K":[14.1,15.4],"L":[11.1,15.3],"M":[14.9,15.4],"N":[12.4,15.4],"O":[15.0,15.6],"P":[12.0,15.4],"Q":[15.6,15.7],"R":[14.1,15.4],"S":[12.7,15.6],"T":[12.4,15.4],"U":[12.4,15.4],"V":[14.5,15.4],"W":[20.0,15.4],"X":[14.7,15.4],"Y":[14.8,15.4],"Z":[12.7,15.4],"0":[10.3,15.4],"1":[7.2,15.4],"2":[10.6,15.4],"3":[10.5,15.4],"4":[11.3,15.4],"5":[10.6,15.2],"6":[10.6,15.4],"7":[10.4,15.2],"8":[10.4,15.4],"9":[10.6,15.4]};
    function sizeText(sh) {
      var k = String(sh).toUpperCase(), z = SIZES[k]; if (!z) return '';
      var nm = k.length === 1 ? (/[0-9]/.test(k) ? 'Number ' + k : k === '&' ? 'The &' : 'Letter ' + k) : (k === 'LOVE' ? 'LOVE' : sh);
      return nm + ': ' + z[0].toFixed(1) + ' cm wide x ' + z[1].toFixed(1) + ' cm tall x 2.2 cm thick, freestanding birch plywood.';
    }
    var sizeEl = null;
    function sizeLine() {
      if (!SHAPEMODE) return;
      if (!sizeEl || !sizeEl.isConnected) {
        var vp = document.querySelector('variant-picker, .variant-picker'); if (!vp) return;
        sizeEl = document.createElement('p'); sizeEl.className = 'sv-aa__sizeline';
        sizeEl.style.cssText = 'margin:.5rem 0 1rem;padding:.55rem .8rem;border-radius:8px;background:rgba(194,160,73,.14);font-size:.92rem;line-height:1.4;color:#0E2B22';
        vp.parentNode.insertBefore(sizeEl, vp.nextSibling);
      }
      var c = document.querySelector('variant-picker input:checked, .variant-picker input:checked');
      sizeEl.textContent = 'Size. ' + sizeText(c ? c.value : curShape());
    }
    function drawShape() {
      sizeLine();
      /* 0.46.6: the name step follows the shape SELECTED (what Add to cart buys), not the spelled letter being previewed */
      var sh = curShape(), selIn = document.querySelector('variant-picker input:checked, .variant-picker input:checked'); nameForShape(selIn ? selIn.value : sh);
      var cap = canvas.parentNode && canvas.parentNode.querySelector('figcaption');
      if (cap) {
        if (!cap.dataset.base) cap.dataset.base = cap.textContent;
        var wr = (typeof word !== 'undefined' && word && word.pv) ? word.rows[word.pvi] : null;
        cap.textContent = wr ? ('Letter ' + wr.ch + ' of ' + word.rows.map(function (x) { return x.ch; }).join('') + (wr.d ? ', with ' + wr.d[1] : ', no design yet') + '. Tap another letter below to see it.') : cap.dataset.base;
      }
      var W = 600, H = Math.round(600 / curRatio());
      canvas.width = W; canvas.height = H;
      ctx.clearRect(0, 0, W, H); ctx.fillStyle = '#F4F1EA'; ctx.fillRect(0, 0, W, H);
      var layer = document.createElement('canvas'); layer.width = W; layer.height = H;
      var l = layer.getContext('2d');
      l.fillStyle = '#E4C99A';            /* birch; set before a letter is drawn, which fills as it draws */
      var kind = shapePath(l, sh, W, H);
      if (kind === 'path') l.fill();
      l.globalCompositeOperation = 'source-atop';
      l.drawImage(shapeFile(W, H, sh), 0, 0);
      ctx.save(); ctx.shadowColor = 'rgba(60,40,10,.35)'; ctx.shadowBlur = 14; ctx.shadowOffsetY = 6;
      ctx.drawImage(layer, 0, 0); ctx.restore();
    }

    /* SPELL A NAME, ONE LETTER EACH, EACH WITH ITS OWN DESIGN. Typing MIA makes three rows; tap a row, then a design
       above, and that letter takes it (the next row is selected for you). Every row posts as its own line with its
       own shape variant and design, so they print, pack and count towards the multi-buy saving separately. */
    var word = { rows: [], active: -1, map: null, el: null };
    function variantMap() {
      if (word.map) return Promise.resolve(word.map);
      return fetch(location.pathname.split('?')[0] + '.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (p) {
        var m = {}; (p.variants || []).forEach(function (v) { if (v.available !== false) m[String(v.option1).toUpperCase()] = v.id; });
        word.map = m; return m;
      });
    }
    function wordUi() {
      if (!SHAPEMODE || word.el) return;
      var anchor = $('.sv-aa__multi', root); if (!anchor) return;
      if (!document.getElementById('sv-aa-word-css')) {
        var css = document.createElement('style'); css.id = 'sv-aa-word-css';
        css.textContent = '.sv-aa__word{margin:1rem 0;padding:1rem;border:2px solid #0E2B22;border-radius:12px;background:#FBF8F1}' +
          '.sv-aa__wh{margin:0 0 .3rem;font-weight:700;font-size:1.05rem;color:#0E2B22}.sv-aa__wp{margin:0 0 .6rem;font-size:.88rem;line-height:1.45}' +
          '.sv-aa__win{width:100%;box-sizing:border-box;min-height:48px;padding:.5rem .8rem;border:1px solid rgba(14,43,34,.35);border-radius:8px;font:inherit;font-size:1.2rem;letter-spacing:.2em;text-transform:uppercase}' +
          '.sv-aa__wl{list-style:none;margin:.7rem 0;padding:0;display:grid;gap:.4rem}' +
          '.sv-aa__wr{display:flex;align-items:center;gap:.6rem;width:100%;min-height:56px;padding:.35rem .6rem;border:2px solid rgba(14,43,34,.2);border-radius:10px;background:#fff;color:#0E2B22;font:inherit;text-align:left;cursor:pointer}' +
          '.sv-aa__wr.is-on{border-color:#0E2B22;box-shadow:0 0 0 2px #0E2B22 inset}.sv-aa__wr img{width:44px;height:44px;object-fit:contain;border-radius:6px;background:#F7F5F0}' +
          '.sv-aa__wc{flex:none;display:inline-flex;align-items:center;justify-content:center;width:2.2rem;height:2.2rem;border-radius:6px;background:#E4C99A;font-weight:800;font-size:1.15rem}' +
          '.sv-aa__wq{display:inline-flex;align-items:center;justify-content:center;width:44px;height:44px;border-radius:6px;border:1px dashed rgba(14,43,34,.4)}' +
          '.sv-aa__wn{font-size:.9rem;line-height:1.3}.sv-aa__wadd{width:100%;min-height:50px;border:0;border-radius:10px;background:#C2A049;color:#0E2B22;font:inherit;font-weight:700;font-size:1rem;cursor:pointer}' +
          '.sv-aa__wadd:disabled{opacity:.55;cursor:not-allowed}.sv-aa__wmsg{margin:.6rem 0 0;font-size:.9rem}.sv-aa__lnote{margin:.4rem 0 1rem;padding:.6rem .8rem;border-left:3px solid #C2A049;background:rgba(194,160,73,.1);font-size:.88rem;line-height:1.45}';
        document.head.appendChild(css);
      }
      var box = document.createElement('div'); box.className = 'sv-aa__word';
      box.innerHTML = '<p class="sv-aa__wh">Spell a name, one letter each</p>' +
        '<p class="sv-aa__wp">Type the letters. Each becomes its own wooden letter, and each can have its own design: tap a letter below, then tap a design above.</p>' +
        '<input type="text" maxlength="12" class="sv-aa__win" placeholder="For example MIA" autocomplete="off" aria-label="Letters to make" data-aa-wordin>' +
        '<ol class="sv-aa__wl" data-aa-wordlist></ol>' +
        '<button type="button" class="sv-aa__wadd" data-aa-wordadd disabled>Type some letters first</button>' +
        '<p class="sv-aa__wmsg" data-aa-wordmsg hidden></p>';
      anchor.parentNode.insertBefore(box, anchor.nextSibling);
      word.el = box;
      var inp = $('[data-aa-wordin]', box);
      inp.addEventListener('input', function () {
        var chars = inp.value.toUpperCase().replace(/[^A-Z0-9&]/g, '').split('');
        var old = word.rows;
        word.rows = chars.map(function (ch, i) { return { ch: ch, d: (old[i] && old[i].ch === ch && old[i].d) || st.pick || null }; });
        word.active = word.rows.length ? Math.min(Math.max(word.active, 0), word.rows.length - 1) : -1;
        if (!word.rows.length) { word.pv = null; draw(); }
        drawWord(); variantMap().then(drawWord).catch(function () {});
      });
      $('[data-aa-wordadd]', box).addEventListener('click', addWord);
    }
    function drawWord() {
      if (!word.el) return;
      var ol = $('[data-aa-wordlist]', word.el), btn = $('[data-aa-wordadd]', word.el);
      ol.innerHTML = '';
      word.rows.forEach(function (r, i) {
        var li = document.createElement('li');
        var b = document.createElement('button'); b.type = 'button';
        b.className = 'sv-aa__wr' + (i === word.active ? ' is-on' : '');
        var tu = r.d ? String(r.d[3] || r.d[7]).split('?')[0] : '';
        if (tu && !/^(https?:)?\/\//.test(tu)) tu = st.cdn + tu;
        var th = r.d ? '<img src="' + esc(tu) + '?width=120" alt="" width="44" height="44">' : '<span class="sv-aa__wq">?</span>';
        b.innerHTML = '<span class="sv-aa__wc">' + esc(r.ch) + '</span>' + th + '<span class="sv-aa__wn">' + (r.d ? esc(r.d[1]) : 'Tap, then pick a design above') + '</span>';
        b.addEventListener('click', function () {
          word.active = i; word.pv = r.ch; word.pvi = i;
          if (r.d) { word.skip = true; try { choose(r.d[0]); } finally { word.skip = false; } } else draw();
          drawWord();
          (grid || root).scrollIntoView({ behavior: 'smooth', block: 'center' });
        });
        li.appendChild(b); ol.appendChild(li);
      });
      var n = word.rows.length, missing = word.rows.filter(function (r) { return !r.d; }).length;
      var wz = word.el.querySelector('.sv-aa__wsize');
      if (!wz) { wz = document.createElement('p'); wz.className = 'sv-aa__wsize'; wz.style.cssText = 'margin:.2rem 0 .7rem;font-size:.88rem;color:#0E2B22'; word.el.querySelector('[data-aa-wordlist]').insertAdjacentElement('afterend', wz); }
      var tw = 0, known = true; word.rows.forEach(function (r) { var z = SIZES[r.ch]; if (z) tw += z[0]; else known = false; });
      wz.hidden = !n || !known;
      wz.textContent = n ? (word.rows.map(function (r) { return r.ch; }).join('') + ' side by side: about ' + Math.round(tw + (n - 1) * 1) + ' cm wide and 15 cm tall, with 1 cm between letters.') : '';
      var bad = word.map ? word.rows.filter(function (r) { return !word.map[r.ch]; }).map(function (r) { return r.ch; }) : [];
      btn.disabled = !n || missing > 0 || bad.length > 0 || !word.map;
      btn.textContent = !n ? 'Type some letters first' : missing ? 'Pick a design for every letter' : bad.length ? ('Not available: ' + bad.join(' ')) : ('Add ' + n + (n === 1 ? ' letter' : ' letters') + ' to cart');
    }
    function wordTake(id) {
      if (word.skip) return false;
      if (!word.el || word.active < 0 || !word.rows.length) return false;
      if (!word.el.getBoundingClientRect().height) return false;
      var d = st.designs.find(function (x) { return x[0] === id; }); if (!d) return false;
      word.rows[word.active].d = d;
      word.pv = word.rows[word.active].ch; word.pvi = word.active;
      if (word.active < word.rows.length - 1) word.active++;
      drawWord();
      return false;          /* the main preview follows the last pick too */
    }
    function addWord() {
      var btn = $('[data-aa-wordadd]', word.el), msg = $('[data-aa-wordmsg]', word.el);
      var spec = ($('[data-aa-specprop]', root) || {}).value || '';
      /* 0.46.6: each line says which word it belongs to and where, so the cart reads PETER as P, E, T, E, R.
         0.46.7: no separate Letter line; the cart already shows Shape: P above it. */
      var spelt = word.rows.map(function (r) { return r.ch; }).join(''), n = word.rows.length;
      var items = word.rows.map(function (r, i) {
        return { id: word.map[r.ch], quantity: 1, properties: { 'Spells': spelt + ', letter ' + (i + 1) + ' of ' + n, 'Design': r.d[1], '_design': r.d[0], '_art': st.cdn + String(r.d[7]).split('?')[0], '_spec': spec } };
      });
      btn.disabled = true; btn.textContent = 'Adding';
      var resolveH, p = new Promise(function (res) { resolveH = res; });
      var ev = new Event('shopify:cart:lines-update', { bubbles: true, cancelable: false });
      ev.action = 'add'; ev.context = 'product'; ev.promise = p;
      ev.lines = items.map(function (l) { return { merchandiseId: 'gid://shopify/ProductVariant/' + l.id, quantity: 1 }; });
      root.dispatchEvent(ev);
      fetch('/cart/add.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: items.slice().reverse() }) })   /* the cart lists the newest line first */
        .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
        .then(function (res) { if (!res.ok) throw new Error(res.j && res.j.description || 'failed'); return fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }); })
        .then(function (cart) {
          resolveH({ cart: { totalQuantity: cart.item_count }, detail: { didError: false, itemCount: cart.item_count, items: cart.items, source: 'sv-anyart' } });
          msg.hidden = false;
          msg.innerHTML = '<strong>Added ' + items.length + (items.length === 1 ? ' letter' : ' letters') + ' (' + esc(word.rows.map(function (r) { return r.ch; }).join('')) + ').</strong> ' + cart.item_count + ' items in your cart. <a href="/cart">Go to cart</a>';
          drawWord();
        })
        .catch(function (e) {
          resolveH({ detail: { didError: true } });
          msg.hidden = false; msg.textContent = 'That did not add: ' + (e.message || 'please try again') + '.';
          drawWord();
        });
    }

    function draw() {
      if (SPEC.panel === 'band') { drawBand(); return; }
      if (SHAPEMODE) { drawShape(); return; }
      var rr = curRatio(), W = 600, H = Math.round(W / rr);
      if (H > 900) { H = 900; W = Math.round(H * rr); }
      canvas.width = W; canvas.height = H;
      var gr = st.mode === 'design' ? ground() : bg;
      /* On a dark product the lettering switches to white by itself (with its pine keyline), until the shopper
         picks a colour themselves; back on a light product it returns to what it was. */
      if (!st.inkManual) {
        var hx = gr.replace('#', ''), lum = (0.299 * parseInt(hx.substr(0, 2), 16) + 0.587 * parseInt(hx.substr(2, 2), 16) + 0.114 * parseInt(hx.substr(4, 2), 16)) / 255;
        if (lum < 0.45 && st.ink.toUpperCase() !== '#FFFFFF') { st.autoPrev = [st.ink, st.inkName]; pickInk('#FFFFFF', 'White'); }
        else if (lum >= 0.45 && st.autoPrev) { pickInk(st.autoPrev[0], st.autoPrev[1]); st.autoPrev = null; }
      }
      ctx.clearRect(0, 0, W, H); ctx.fillStyle = gr; ctx.fillRect(0, 0, W, H);
      var img = st.mode === 'design' ? st.img : st.upImg;
      var name = nameEl.value.trim();
      /* A folded card prints on its whole outside; the front cover is the right half. */
      /* A wrap-around mug prints the artwork twice, one on each side, so it faces out whichever hand holds it. */
      var X0 = SPEC.panel === 'right' ? Math.round(W / 2) : 0, CW = SPEC.panel === 'both' ? Math.floor(W / 2) : W - X0;
      if (X0) { ctx.save(); ctx.strokeStyle = 'rgba(14,43,34,.25)'; ctx.setLineDash([6, 6]); ctx.beginPath(); ctx.moveTo(X0, 0); ctx.lineTo(X0, H); ctx.stroke(); ctx.restore(); }
      var pad = Math.round(Math.min(CW, H) * (parseFloat(SPEC.safe) || 0.05));
      var band = name ? Math.round(H * 0.2) : 0;
      if (img) {
        var bw = CW - pad * 2, bh = H - pad * 2 - band;
        var s = Math.min(bw / img.naturalWidth, bh / img.naturalHeight);
        var dw = img.naturalWidth * s, dh = img.naturalHeight * s;
        ctx.drawImage(img, X0 + (CW - dw) / 2, pad + (bh - dh) / 2, dw, dh);
      } else {
        ctx.strokeStyle = 'rgba(14,43,34,.25)'; ctx.setLineDash([8, 6]); ctx.lineWidth = 2;
        ctx.strokeRect(X0 + pad, pad, CW - pad * 2, H - pad * 2 - band); ctx.setLineDash([]);
        ctx.fillStyle = 'rgba(14,43,34,.45)'; ctx.textAlign = 'center'; ctx.textBaseline = 'middle';
        ctx.font = '600 ' + Math.max(14, Math.round(W / 26)) + 'px system-ui, sans-serif';
        ctx.fillText('Your artwork goes here', X0 + CW / 2, (H - band) / 2);
      }
      if (name) {
        var size = Math.round(band * 0.62), face = st.face;
        ctx.textAlign = 'center'; ctx.textBaseline = 'middle';
        var text = (face === 'Luckiest Guy' || face === 'Bangers') ? name.toUpperCase() : name;
        do { ctx.font = size + 'px "' + face + '", system-ui, sans-serif'; size -= 2; }
        while (ctx.measureText(text).width > CW - pad * 2 && size > 10);
        var y = H - pad - band / 2;
        if (st.ink.toUpperCase() === '#FFFFFF' || st.ink.toUpperCase() === '#C2A049') {
          ctx.lineWidth = Math.max(2, size / 9); ctx.strokeStyle = '#0E2B22'; ctx.lineJoin = 'round'; ctx.strokeText(text, X0 + CW / 2, y);
        }
        ctx.fillStyle = st.ink; ctx.fillText(text, X0 + CW / 2, y);
      }
      if (SPEC.panel === 'both') { var hw = Math.floor(W / 2); ctx.drawImage(canvas, 0, 0, hw, H, W - hw, 0, hw, H); }
    }
    if (document.fonts && document.fonts.load) {
      ['Luckiest Guy', 'Bangers', 'Great Vibes', 'Baloo 2'].forEach(function (f) { document.fonts.load('40px "' + f + '"').then(draw).catch(function () {}); });
    }

    /* ---- 0.42.2: HOW MANY, AND MAKE ANOTHER ----
       Tony: "how to order multiples, needs to be very simple". The theme's own quantity box is hidden on these
       pages, so there was no way to order two. This stepper drives the product form's quantity (or posts as it,
       where the form has none), says what the multi-buy saving is at that number, and after an add offers
       Make another, which clears the name and goes back to step 1, for a set where each one is different. */
    var qEl = $('[data-aa-qty]', root), saveEl = $('[data-aa-save]', root);
    var addedEl = $('[data-aa-added]', root), addedTxt = $('[data-aa-addedtxt]', root);
    var TIERS = [[5, 20], [3, 15], [2, 10]], SAVE0 = saveEl ? saveEl.innerHTML : '';
    function formQty() { var f = form(); var q = f ? f.querySelector('input[name="quantity"]') : null; return q === qEl ? null : q; }
    function syncQty() {
      if (!qEl) return;
      var n = Math.max(1, Math.min(50, parseInt(qEl.value, 10) || 1)); qEl.value = n;
      var fq = formQty();
      if (fq) { qEl.removeAttribute('name'); if (String(fq.value) !== String(n)) fq.value = n; }
      else qEl.setAttribute('name', 'quantity');
      var t = TIERS.filter(function (x) { return n >= x[0]; })[0];
      if (saveEl) saveEl.innerHTML = t ? '<strong>' + n + ' of these: ' + t[1] + '% off each</strong>, taken off at the checkout. Other personalised pieces in your cart count towards it too.' : SAVE0;
    }
    if (qEl) {
      qEl.addEventListener('input', syncQty); qEl.addEventListener('change', syncQty);
      $('[data-aa-qminus]', root).addEventListener('click', function () { qEl.value = (parseInt(qEl.value, 10) || 1) - 1; syncQty(); });
      $('[data-aa-qplus]', root).addEventListener('click', function () { qEl.value = (parseInt(qEl.value, 10) || 1) + 1; syncQty(); });
    }
    var cartCount = null;
    function readCart() { return fetch('/cart.js', { cache: 'no-store', credentials: 'same-origin' }).then(function (r) { return r.json(); }); }
    readCart().then(function (c) { cartCount = c.item_count; }).catch(function () {});
    function watchAdd() {
      var tries = 0;
      (function poll() {
        setTimeout(function () {
          readCart().then(function (c) {
            if (cartCount !== null && c.item_count > cartCount) {
              var got = c.item_count - cartCount; cartCount = c.item_count;
              addedTxt.innerHTML = '<strong>Added ' + (got === 1 ? 'one' : got) + ' to your cart.</strong> ' + c.item_count + (c.item_count === 1 ? ' item' : ' items') + ' in your cart now.';
              addedEl.hidden = false;
            } else if (++tries < 16) poll();
            else cartCount = c.item_count;
          }).catch(function () {});
        }, 500);
      })();
    }
    /* 0.46.8: THE GALLERY SHOWS WHAT IS BEING BUILT, AND THE CART GETS THE SAME PICTURE.
       Tony, 25 Sep 2026, on the lunch bag with Golden Bell and Holly picked and the koala sample still filling the
       gallery: "go through every custom product and ensure it changes the view on the product to the graphic selected
       ... and also every custom product is what is seen at cart page what has been built".
       1. The first gallery photo (grid on desktop, first slide on a phone) is covered by the live preview the moment a
          design is picked or a photo uploaded, and it follows every change: design, name, lettering, colour, letter
          or shape. "See product photo" puts the photo back until the next pick.
       2. On Add to cart that same drawing is attached to the line as the hidden file _preview, so the cart, the drawer
          and the order show exactly what was built (sv-cart-art.js draws it first). */
    var gal = { off: false, pick: null, up: null };
    if (!document.getElementById('sv-aa-gal-css')) {
      var gcss = document.createElement('style'); gcss.id = 'sv-aa-gal-css';
      gcss.textContent = '.sv-aa-gal{position:absolute;inset:0;z-index:3;display:flex;align-items:center;justify-content:center;background:#F7F5F0;border-radius:inherit;overflow:hidden}' +
        '.sv-aa-gal[hidden]{display:none}.sv-aa-gal canvas{display:block;max-width:92%;max-height:92%;width:auto;height:auto}' +
        '.sv-aa-gal__tag{position:absolute;left:10px;top:10px;background:#0E2B22;color:#F4EEE2;font-size:12px;font-weight:700;line-height:1;padding:7px 10px;border-radius:999px;letter-spacing:.02em}' +
        '.sv-aa-gal__x{position:absolute;right:10px;bottom:10px;min-height:36px;padding:0 12px;border:1px solid #0E2B22;background:#fff;color:#0E2B22;font:inherit;font-size:13px;font-weight:600;border-radius:999px;cursor:pointer}';
      document.head.appendChild(gcss);
    }
    function galHosts() {
      /* the first photo of each layout: the phone slideshow, the desktop grid and the zoom dialog */
      return Array.prototype.slice.call(document.querySelectorAll('media-gallery slideshow-slides > .product-media-container:first-child, media-gallery .media-gallery__grid > .product-media-container:first-child, media-gallery .dialog-zoomed-gallery > .product-media-container:first-child')).map(function (c) {
        return c.querySelector('.product-media') || c;
      });
    }
    function galMirror() {
      if (st.pick !== gal.pick || st.upImg !== gal.up) { gal.off = false; gal.pick = st.pick; gal.up = st.upImg; }
      var on = !!(st.pick || st.upImg) && !gal.off && canvas.width > 0;
      galHosts().forEach(function (h) {
        var ov = h.querySelector('.sv-aa-gal');
        if (!on) { if (ov) ov.hidden = true; return; }
        if (!ov) {
          ov = document.createElement('div'); ov.className = 'sv-aa-gal';
          ov.innerHTML = '<canvas role="img" aria-label="Your design, as it will print"></canvas><span class="sv-aa-gal__tag">Your design</span>' +
            '<button type="button" class="sv-aa-gal__x">See product photo</button>';
          if (getComputedStyle(h).position === 'static') h.style.position = 'relative';
          ov.addEventListener('click', function (e) { e.stopPropagation(); if (!e.target.closest('.sv-aa-gal__x')) e.preventDefault(); }, true);
          ov.querySelector('.sv-aa-gal__x').addEventListener('click', function (e) { e.preventDefault(); gal.off = true; galMirror(); });
          h.appendChild(ov);
        }
        ov.hidden = false;
        var c = ov.querySelector('canvas');
        if (c.width !== canvas.width || c.height !== canvas.height) { c.width = canvas.width; c.height = canvas.height; }
        var x = c.getContext('2d'); x.clearRect(0, 0, c.width, c.height); x.drawImage(canvas, 0, 0);
      });
    }
    var svDraw0 = draw;
    var pvT = null;
    draw = function () { svDraw0.apply(this, arguments); try { galMirror(); } catch (e) {} clearTimeout(pvT); pvT = setTimeout(function () { if (ready()) previewFile(); }, 250); };
    var galPend = false, galHost = document.querySelector('.product-information__media') || document.querySelector('main') || document.body;
    new MutationObserver(function () {
      if (galPend) return; galPend = true;
      requestAnimationFrame(function () { galPend = false; if ((st.pick || st.upImg) && !gal.off && galHosts().some(function (h) { return !h.querySelector('.sv-aa-gal'); })) galMirror(); });
    }).observe(galHost, { childList: true, subtree: true });
    function previewFile() {
      var inp = $('[data-aa-preview]', root); if (!inp || typeof DataTransfer === 'undefined') return;
      try {
        var W = canvas.width, H = canvas.height, k = Math.min(1, 700 / Math.max(W, H));
        var c = document.createElement('canvas'); c.width = Math.max(1, Math.round(W * k)); c.height = Math.max(1, Math.round(H * k));
        var x = c.getContext('2d'); x.fillStyle = '#FFFFFF'; x.fillRect(0, 0, c.width, c.height); x.drawImage(canvas, 0, 0, c.width, c.height);
        var d = c.toDataURL('image/jpeg', 0.86), b = atob(d.split(',')[1]), u = new Uint8Array(b.length);
        for (var i = 0; i < b.length; i++) u[i] = b.charCodeAt(i);
        var dt = new DataTransfer(); dt.items.add(new File([u], 'your-design-preview.jpg', { type: 'image/jpeg' }));
        inp.files = dt.files; inp.disabled = false;
      } catch (e) { try { inp.value = ''; inp.disabled = true; } catch (e2) {} }
    }
    /* The theme builds its add request on the button press, before the submit event, so the file is refreshed after
       every redraw (above) and again the moment an Add to cart button is pressed. */
    ['pointerdown', 'keydown'].forEach(function (t) {
      document.addEventListener(t, function (e) {
        var b = e.target && e.target.closest && e.target.closest('button, [type="submit"]'); var f = form();
        if (b && f && (b.form === f || f.contains(b)) && ready()) previewFile();
      }, true);
    });
    document.addEventListener('submit', function (e) { if (e.target === form() && ready()) previewFile(); }, true);
    document.addEventListener('submit', function (e) { if (e.target === form() && ready()) watchAdd(); });
    if (addedEl) $('[data-aa-another]', root).addEventListener('click', function () {
      addedEl.hidden = true;
      nameEl.value = ''; nameEl.dispatchEvent(new Event('input', { bubbles: true }));
      if (qEl) { qEl.value = 1; syncQty(); }
      $('.sv-aa__step', root).scrollIntoView({ behavior: 'smooth', block: 'start' });
    });

    wordUi();
    adopt(); if (grid) load(); draw(); gate();
    syncQty();
    /* 0.42.2: a colour change repaints the ground at once, not only on the next animation frame. */
    document.addEventListener('change', function (e) { if (e.target && e.target.closest && e.target.closest('variant-picker, .variant-picker')) { if (word) word.pv = null; setTimeout(draw, 30); } });
    /* 0.46.6: tapping the shape already selected fires no change, so it also has to bring the preview back to it */
    document.addEventListener('click', function (e) { if (word && word.pv && e.target && e.target.closest && e.target.closest('variant-picker, .variant-picker')) { word.pv = null; setTimeout(draw, 60); } });
    /* Horizon re-renders the buy buttons on a variant change, which drops our disabled state. */
    var pend = false;
    new MutationObserver(function () {
      if (pend) return; pend = true;
      requestAnimationFrame(function () { pend = false; adopt(); gate(); draw(); syncQty(); });
    }).observe(document.body, { childList: true, subtree: true });
  }

  function start() {
    var r = document.querySelector('[data-sv-anyart]');
    if (r && !r.dataset.svOn) { r.dataset.svOn = '1'; boot(r); }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
  document.addEventListener('shopify:section:load', start);
})();
